<template>
  <tr>
    <td colspan="100%" class="p-4 text-center text-gray-600 border-b">
      <slot />
    </td>
  </tr>
</template>
